const useWebsiteSettingStore = defineStore("websiteSetting", () => {
  const authStore = useAuthStore()
  const walletStore = useWalletStore()
  const websiteInfoStore = useWebsiteInfoStore()

  const enableSparkLocalStorage = useLocalStorage<boolean>("enableSpark", true, {
    needLogin: true
  })
  const fancyBetAndBookMakerAcceptAnyOddsLocalStorage = useLocalStorage<boolean>(
    "fancyBetAndBookMakerAcceptAnyOddsLocalStorage",
    true,
    {
      needLogin: true
    }
  )
  const sportsBookAcceptAnyOddsLocalStorage = useLocalStorage<boolean>(
    "sportsBookAcceptAnyOdds",
    true,
    {
      needLogin: true
    }
  )
  const geniusSportsAcceptAnyOddsLocalStorage = useLocalStorage<boolean>(
    "geniusSportsAcceptAnyOdds",
    true,
    {
      needLogin: true
    }
  )

  const oneClickBetLocalStorage = useLocalStorage("oneClickBet", {
    index: 0,
    isRead: false,
    isConfirm: false
  })

  const certificationLocalStorage = useLocalStorage<{
    resetPassword: boolean
    termsVersion: number[]
  }>("certification", {
    resetPassword: false,
    termsVersion: []
  })

  const headerBlockHeight = ref("0px")

  const timeZone = computed(() => websiteInfoStore.state.timeZone)
  const currentType = computed(() => walletStore.currency.type)
  const defaultChip = computed(() => walletStore.currency.defaultChip)
  const currentSymbol = computed(() => walletStore.currency.symbol)
  const customizeStakeStr = computed(() => authStore.playerInfo.customizeStake ?? "")
  const oneClickBetStakeStr = computed(() => authStore.playerInfo.oneClickBetStake ?? "")
  const coinPreferenceStr = computed(
    () => authStore.playerInfo.coinPreference ?? "1,2,3,4,5,6"
  )
  const defaultValue = computed(() =>
    authStore.playerInfo.userCoin === 0 ? "" : authStore.playerInfo.userCoin
  )
  const enableForecastWithCommission = computed(
    () => authStore.playerInfo.enableForecastWithCommission === 1
  )
  const coinsPreference = computed(() => coinPreferenceStr.value.split(",").map(Number))
  const customizeStake = computed<{ amount: number; display: string }[]>(() => {
    if (
      customizeStakeStr.value !== "" &&
      customizeStakeStr.value !== null &&
      customizeStakeStr.value !== undefined
    ) {
      return customizeStakeStr.value.split(",").map((node: string) => ({
        amount: Number(node),
        display: `${node}`
      }))
    }

    return defaultChip.value
  })
  const oneClickBetStake = computed<{ amount: number; display: string }[]>(() => {
    if (
      oneClickBetStakeStr.value !== "" &&
      oneClickBetStakeStr.value !== null &&
      oneClickBetStakeStr.value !== undefined
    ) {
      return oneClickBetStakeStr.value.split(",").map((node: string) => ({
        amount: Number(node),
        display: `${node}`
      }))
    }

    return defaultChip.value
  })
  const isOneClickBet = computed(
    () => oneClickBetLocalStorage.localStorage.value.isConfirm
  )

  const choiceOneClickBetStakeIndex = computed(
    () => oneClickBetLocalStorage.localStorage.value.index
  )
  const choiceOneClickBetStake = computed(
    () =>
      (
        oneClickBetStake.value[choiceOneClickBetStakeIndex.value] || {
          amount: 0,
          display: "0"
        }
      ).amount
  )

  const updateHeaderBlockHeight = (height: string) => {
    headerBlockHeight.value = height
  }

  const toggleIsOneClickBet = (value: boolean) => {
    oneClickBetLocalStorage.update({
      index: oneClickBetLocalStorage.localStorage.value.index,
      isRead: oneClickBetLocalStorage.localStorage.value.isRead,
      isConfirm: value
    })
  }

  const resetIsOneClickBet = () => {
    oneClickBetLocalStorage.update({ index: 0, isRead: false, isConfirm: false })
  }

  return {
    timeZone,
    currentType,
    defaultValue,
    currentSymbol,
    isOneClickBet,
    customizeStake,
    coinsPreference,
    oneClickBetStake,
    headerBlockHeight,
    choiceOneClickBetStake,
    choiceOneClickBetStakeIndex,
    enableForecastWithCommission,
    certificationLocalStorage: computed(() => certificationLocalStorage),
    oneClickBetLocalStorage: computed(() => oneClickBetLocalStorage),
    enableSparkLocalStorage: computed(() => enableSparkLocalStorage),
    fancyBetAndBookMakerAcceptAnyOddsLocalStorage: computed(
      () => fancyBetAndBookMakerAcceptAnyOddsLocalStorage
    ),
    sportsBookAcceptAnyOddsLocalStorage: computed(
      () => sportsBookAcceptAnyOddsLocalStorage
    ),
    geniusSportsAcceptAnyOddsLocalStorage: computed(
      () => geniusSportsAcceptAnyOddsLocalStorage
    ),
    toggleIsOneClickBet,
    resetIsOneClickBet,
    updateHeaderBlockHeight
  }
})

export default useWebsiteSettingStore
